import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import Image from 'next/image';
import { FindAHomeNoListingsStyles } from './FindAHomeNoListings.styled';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import { LocationsContext } from '@contexts/LocationsContext';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import dynamic from 'next/dynamic';

const PromptUserForLocation = dynamic(
  () => import('@components/FindAHome/PromptUserForLocation'),
  { ssr: false }
);

const FindAHomeNoListings = ({ onExpandRange }) => {
  const locationsContext = useContext(LocationsContext);

  // run the effect once to push the event when 'no homes' is displayed
  useEffect(() => {
    pushGTMEvent('ch.home_search_no_results');
  }, []); // PCC-5676

  const handleClick = () => {
    if (onExpandRange) {
      onExpandRange();
    }
  };

  const isMobile = window.innerWidth <= desktop_breakpoint_extended;

  // NOTE: 67050 is the default zip code for any iOS user that does not provide location.
  // If a mobile user is in 67050, prompt the user for their coordinates to get more accurate location data.
  const promptUserForLocation =
    isMobile &&
    navigator?.geolocation &&
    locationsContext.state.geocode?.postalCode === '67050';

  return (
    <FindAHomeNoListingsStyles>
      <div className="no-listings-container">
        <h3>No homes match your filter selections</h3>
        <p className="intro">
          Remove some of your filters or
          <a
            href="#"
            tabIndex="0"
            className="expand"
            onClick={(e) => {
              handleClick();
              e.preventDefault();
            }}
          >
            {' '}
            expand the distance{' '}
          </a>
          of your search.
        </p>

        <div className="illustration-container">
          <Image
            className="illustration"
            src="/public-assets/images/no-homes-illustration.svg"
            alt="No Homes Illustration"
            fill
          />
        </div>
      </div>
      {/* NOTE: this was separated out into a different component to load Google Maps code conditionally */}
      {promptUserForLocation && <PromptUserForLocation />}
    </FindAHomeNoListingsStyles>
  );
};

FindAHomeNoListings.propTypes = {
  isMobile: PropTypes.bool,
  onGetGeoLocation: PropTypes.func,
  onExpandRange: PropTypes.func,
};

export default FindAHomeNoListings;
